import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import {
  EvaluationResult,
  EvaluationScoreHistogramBin,
} from '../models/quality.models';

@Component({
  selector: 'app-evaluation-score-histogram',
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatSelectModule],
  templateUrl: './evaluation-score-histogram.component.html',
  styleUrls: ['./evaluation-score-histogram.component.scss'],
})
export class EvaluationScoreHistogramComponent {
  @Input() results: EvaluationResult[] = [];
  metric = '';
  get metrics(): string[] {
    return [...new Set(this.results.map((item) => item.metricName))];
  }
  get bins(): EvaluationScoreHistogramBin[] {
    const values = this.results.filter(
      (item) => !this.metric || item.metricName === this.metric
    );
    const ranges = [
      { label: '0–19%', min: 0, max: 0.2 },
      { label: '20–39%', min: 0.2, max: 0.4 },
      { label: '40–59%', min: 0.4, max: 0.6 },
      { label: '60–79%', min: 0.6, max: 0.8 },
      { label: '80–100%', min: 0.8, max: 1.000001 },
    ];
    return ranges.map((range) => ({
      label: range.label,
      count: values.filter(
        (item) => item.score >= range.min && item.score < range.max
      ).length,
    }));
  }
  maxCount(): number {
    return Math.max(1, ...this.bins.map((bin) => bin.count));
  }
}
